// 在前端 fetch 層正規化，改各服務的 GET API 函式，後續元件一律使用真正的 null
export function normalizeNulls<T>(data: T): T {
  if (data === 'null') return null as unknown as T;
  if (Array.isArray(data)) return data.map(normalizeNulls) as unknown as T;
  if (data !== null && typeof data === 'object') {
    return Object.fromEntries(
      Object.entries(data).map(([k, v]) => [k, normalizeNulls(v)]),
    ) as T;
  }
  return data;
}
